import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import Sample14 from "../../Components/Logo";
import { useAuth } from '../../Context/AuthContext';
import { toast } from "react-toastify";
import { saveNewLead } from '../../Api/CRMAPI/rawleads';
import { useCRMDataContext } from '../../Context/CRMContext';
import { useNavigate } from "react-router-dom";

const CreateRawLead = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const { leadSource,
        loadLeadSourceData } = useCRMDataContext();
    const [loading, setLoading] = useState(false);

    const intitalValues = {
        importSource: "",
        customerName: "",
        email: "",
        contactNumber: "",
        username: user.userId,
        socialMediaLink:"",
    }

    console.log(user.userId, 'user')

    const handleChange = (e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    };

    const [formValues, setFormValues] = useState(intitalValues);

    const handleSubmit = async (e) => {
        const { customerName, email, contactNumber } = formValues;

        e.preventDefault();
        if (!formValues.customerName && !formValues.email && !formValues.contactNumber) {
            toast.error("Please provide at least one: Name, Email, or Contact Number");
            return;
        }
        if (email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                toast.error("Please enter a valid email address");
                return;
            }
        }

        // Contact number validation (must be exactly 10 digits)
        if (contactNumber) {
            const phoneRegex = /^[0-9]{10}$/;
            if (!phoneRegex.test(contactNumber)) {
                toast.error("Contact number must be exactly 10 digits");
                return;
            }
        }

        setLoading(true);
        try {
            const res = await saveNewLead(formValues, user.userId)
            if (res.status === 200) {
                toast.success(`🦄 Added Successfully`);
                setFormValues(intitalValues);
                navigate("/crm/raw-leads");
            }
            console.log(res, 'res from backend')
        }
        catch (error) {
            toast.error(`🦄 Error : ${error.message}`);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadLeadSourceData()
    }, [])

    return (
        <>
            <div className="main-content expand">
                <Container fluid className="fields-container">
                    <h2 className="fields-title page-title-heading">Add Raw Lead</h2>

                    {loading && (
                        <div className="loading-overlay">
                            <Sample14 />
                        </div>
                    )}

                    <Form onSubmit={handleSubmit} className="fields-form">
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>ImportSource <span className="text-red">**</span></Form.Label>
                                    <Form.Select
                                        name="importSource"
                                        value={formValues.importSource}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Source</option>
                                        {leadSource.map((option) => (
                                            <option key={option.codeId} value={option.codeId}>
                                                {option.codeId} - {option?.sourceDescription}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Name </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="customerName"
                                        value={formValues.customerName}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                            {/* </Row> */}

                            {/* <Row> */}
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email Id </Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formValues.email}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Contact Number </Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="contactNumber"
                                        value={formValues.contactNumber}
                                        onChange={handleChange}

                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                   <Form.Group className="mb-3">
                                    <Form.Label>Social Meida Link </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="socialMediaLink"
                                        value={formValues.socialMediaLink}
                                        onChange={handleChange}
                                    />
                                </Form.Group>       
                            </Col>
                        </Row>
                        <div className="fields-btn-container">
                            <Button
                                variant="primary"
                                type="submit"
                                className="fields-submit"
                                disabled={loading}
                            >
                                {loading ? "Saving..." : "Save Data"}
                            </Button>
                        </div>
                    </Form>
                </Container>
            </div>
        </>
    )
}

export default CreateRawLead